import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-gift-center-home-preview-modal',
  templateUrl: './gift-center-home-preview-modal.component.html',
  styleUrls: ['./gift-center-home-preview-modal.component.css']
})
export class GiftCenterHomePreviewModalComponent implements AfterViewInit {
  @Input() previewUrl: string;
  @Input() givePreviewUrl: string;

  @ViewChild('previewFrame', {static: true}) previewFrame: ElementRef<HTMLIFrameElement>;

  public loadingPreview = true;
  public activePage: 'home' | 'give' = 'home';

  constructor(
    public activeModal: NgbActiveModal,
  ) {}

  ngAfterViewInit() {
    const frame = this.previewFrame.nativeElement;
    frame.addEventListener('load', () => { this.loadingPreview = false; });
    frame.src = this.previewUrl;
  }

  public showPage(page: 'home' | 'give') {
    if (page === this.activePage) {
      return;
    }
    this.activePage = page;
    this.loadingPreview = true;
    this.previewFrame.nativeElement.src = page === 'give' ? this.givePreviewUrl : this.previewUrl;
  }
}
